/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_scatter_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What data does a scatter plot need?`)
};

const es_scatter_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué datos necesita un diagrama de dispersión?`)
};

const de_scatter_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Daten benötigt ein Streudiagramm?`)
};

const nl_scatter_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke data heeft een spreidingsdiagram nodig?`)
};

const fr_scatter_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelles données un nuage de points nécessite-t-il ?`)
};

const it_scatter_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che dati servono per un grafico a dispersione?`)
};

const pt_br2_scatter_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dados um gráfico de dispersão precisa?`)
};

const pt_scatter_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dados precisa um gráfico de dispersão?`)
};

const ja_scatter_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`散布図にはどのようなデータが必要ですか？`)
};

const zh_scatter_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`散点图需要什么数据？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const scatter_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.scatter_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("scatter_faq_q1", locale)
	if (locale === "en") return en_scatter_faq_q1(inputs)
	if (locale === "es") return es_scatter_faq_q1(inputs)
	if (locale === "de") return de_scatter_faq_q1(inputs)
	if (locale === "nl") return nl_scatter_faq_q1(inputs)
	if (locale === "fr") return fr_scatter_faq_q1(inputs)
	if (locale === "it") return it_scatter_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_scatter_faq_q1(inputs)
	if (locale === "pt") return pt_scatter_faq_q1(inputs)
	if (locale === "ja") return ja_scatter_faq_q1(inputs)
	return zh_scatter_faq_q1(inputs)
};